import React, { useState } from 'react';
import { FaRuler, FaCheck } from 'react-icons/fa';

const MeasurementTools = ({ onUnitSelect, selectedUnit }) => {
  const [isOpen, setIsOpen] = useState(false);

  const measurementUnits = [
    { 
      id: 'feet', 
      name: 'Feet', 
      symbol: 'ft', 
      abbreviation: "'",
      description: 'Imperial system - feet',
      conversionFactor: 3.28084,
    },
    { 
      id: 'inches', 
      name: 'Inches', 
      symbol: 'in', 
      abbreviation: '"',
      description: 'Imperial system - inches',
      conversionFactor: 39.3701,
    },
    { 
      id: 'meters', 
      name: 'Meters', 
      symbol: 'm', 
      abbreviation: 'm',
      description: 'Metric system - meters',
      conversionFactor: 1,
    },
    { 
      id: 'centimeters', 
      name: 'Centimeters', 
      symbol: 'cm', 
      abbreviation: 'cm',
      description: 'Metric system - centimeters',
      conversionFactor: 100,
    },
    { 
      id: 'millimeters', 
      name: 'Millimeters', 
      symbol: 'mm', 
      abbreviation: 'mm',
      description: 'Metric system - millimeters',
      conversionFactor: 1000,
    },
  ];

  const handleUnitSelect = (unit) => {
    onUnitSelect(unit);
    setIsOpen(false);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: '8px 12px',
          border: 'none',
          borderRadius: '6px',
          background: selectedUnit 
            ? 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)' 
            : 'linear-gradient(135deg, #1a1a1a 0%, #404040 100%)',
          color: 'white',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '14px',
          fontWeight: '600',
          width: '100%',
          justifyContent: 'flex-start'
        }}
      >
        <FaRuler />
        Units
        {selectedUnit && (
          <span style={{ fontSize: '12px', opacity: 0.8 }}>
            ({selectedUnit.symbol})
          </span>
        )}
      </button>

      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: '280px',
            right: '420px',
            background: 'linear-gradient(135deg, #1a1a1a 0%, #404040 100%)',
            border: '1px solid #333',
            borderRadius: '8px',
            padding: '16px',
            zIndex: 2500,
            minWidth: '280px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
          }}
        >
          <div style={{ marginBottom: '12px', fontWeight: 'bold', color: 'white' }}>
            Measurement Units
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {measurementUnits.map((unit) => {
              return (
                <div
                  key={unit.id}
                  onClick={() => handleUnitSelect(unit)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '12px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    background: selectedUnit?.id === unit.id ? 'rgba(255,255,255,0.2)' : 'transparent',
                    transition: 'background 0.2s ease',
                    border: selectedUnit?.id === unit.id ? '1px solid rgba(255,255,255,0.3)' : '1px solid transparent'
                  }}
                >
                  <FaRuler style={{ color: 'white', fontSize: '16px' }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ color: 'white', fontWeight: '600', fontSize: '14px' }}>
                      {unit.name} ({unit.symbol})
                    </div>
                    <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '12px' }}>
                      {unit.description}
                    </div>
                    <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '11px', marginTop: '2px' }}>
                      {unit.conversionFactor === 1 ? 'Base unit' : `1m = ${unit.conversionFactor.toFixed(2)} ${unit.symbol}`}
                    </div>
                  </div>
                  {selectedUnit?.id === unit.id && (
                    <FaCheck style={{ color: 'white', fontSize: '14px' }} />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default MeasurementTools;
